import React from "react";
import { useSelector } from "react-redux";
import { Grid, Paper, Typography, Box, LinearProgress, makeStyles } from "@material-ui/core";

import { getMetric } from "../../../../store/hub/conversionMetrics";

export default function TargetProgressWidget({ metricIdAndValue, paperClassName, compact }) {
  const classes = useStyles();
  const metric = useSelector((state) => getMetric(state.entities.conversionMetrics, metricIdAndValue?.id));

  if (!metricIdAndValue?.targetText || metricIdAndValue?.target == null) {
    return null;
  }

  const valueNumeric = metricIdAndValue.valueNumeric ?? 0;
  const progressPercent =
    metricIdAndValue.target > 0
      ? Math.min(100, valueNumeric / metricIdAndValue.target * 100)
      : 0;
  const targetMet = metricIdAndValue.target > 0 && valueNumeric >= metricIdAndValue.target;

  return (
    <Grid
      key="target-progress"
      item
      className={paperClassName ? `${classes.topPaper} ${paperClassName}` : classes.topPaper}
    >
      <Paper className={compact ? `${classes.widgetPaper} ${classes.widgetPaperCompact}` : classes.widgetPaper}>
        <Box className={classes.paperContent}>
          <Typography className={classes.headerText} variant="body2">
            {metric?.tooltipText ?? ""}
          </Typography>
          <Typography className={classes.targetText} variant="body2">
            {metricIdAndValue.targetText}
          </Typography>
          <LinearProgress
            className={`${classes.progressBar} ${targetMet ? classes.progressBarMet : ""}`}
            variant="determinate"
            value={progressPercent}
            color="primary"
          />
        </Box>
      </Paper>
    </Grid>
  );
}

const useStyles = makeStyles((theme) => ({
  widgetPaper: {
    [theme.breakpoints.only("xs")]: {
      height: 90,
      padding: theme.spacing(1),
      width: "auto",
      minWidth: "30vw",
    },
    [theme.breakpoints.up("sm")]: {
      height: 80,
      padding: theme.spacing(2),
      width: "auto",
    },
    [theme.breakpoints.only("xl")]: {
      height: 100,
      padding: theme.spacing(2),
      width: "auto",
    },
    color: "rgb(135, 131, 131)",
  },
  paperContent: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    justifyContent: "space-evenly",
  },
  widgetPaperCompact: {
    [theme.breakpoints.only("xs")]: {
      height: 60,
      padding: theme.spacing(1),
      paddingRight: theme.spacing(2),
    },
    [theme.breakpoints.up("sm")]: {
      height: 56,
      padding: theme.spacing(1.5),
      paddingRight: theme.spacing(2.5),
    },
    [theme.breakpoints.only("xl")]: {
      height: 64,
      padding: theme.spacing(1.5),
      paddingRight: theme.spacing(3),
    },
  },
  headerText: {
    [theme.breakpoints.only("xs")]: {
      fontSize: 14,
    },
    [theme.breakpoints.up("sm")]: {
      fontSize: 14,
    },
    [theme.breakpoints.up("lg")]: {
      fontSize: 16,
    },
    [theme.breakpoints.only("xl")]: {
      fontSize: 20,
    },
    color: "rgb(100, 100, 100)",
    fontWeight: "bold",
    lineHeight: 1.3,
  },
  topPaper: {
    [theme.breakpoints.only("xs")]: {
      marginBottom: theme.spacing(1),
      width: "100%",
    },
    [theme.breakpoints.up("sm")]: {
      marginBottom: theme.spacing(3),
    },
  },
  targetText: {
    [theme.breakpoints.only("xs")]: {
      fontSize: 14,
    },
    [theme.breakpoints.up("sm")]: {
      fontSize: 14,
    },
    [theme.breakpoints.up("lg")]: {
      fontSize: 16,
    },
    [theme.breakpoints.only("xl")]: {
      fontSize: 20,
    },
    color: "rgb(100, 100, 100)",
    lineHeight: 1.3,
  },
  progressBar: {
    height: 14,
    borderRadius: 7,
  },
  progressBarMet: {
    "& .MuiLinearProgress-bar": {
      backgroundColor: theme.palette.success.main,
    },
  },
}));
